/**
 * Resize window event
 */

import PubSub from 'pubsub-js';

function debounce(func){
    let timer;
    return function(event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func,100,event);
    };
}

// Store the window width
let windowWidth = window.innerWidth;

window.addEventListener("resize", debounce(function(e){

    // Check window width has actually changed and
    // it's not just iOS triggering a resize event on scroll
    if (window.innerWidth !== windowWidth) {
        PubSub.publish('resizeDone', e);

        // Update the window width for next time
        windowWidth = window.innerWidth;
    }
}));